export const reviewArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 11 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.14835 8.95225C0.679718 9.42088 0.679718 10.1807 1.14835 10.6493L8.7851 18.2861C9.25373 18.7547 10.0135 18.7547 10.4822 18.2861C10.9508 17.8174 10.9508 17.0576 10.4822 16.589L3.69393 9.80078L10.4822 3.01256C10.9508 2.54393 10.9508 1.78413 10.4822 1.3155C10.0135 0.84687 9.25373 0.84687 8.7851 1.3155L1.14835 8.95225ZM3.79688 8.60078H1.99688L1.99688 11.0008H3.79688V8.60078Z"
      fill="white"
    />
  </svg>
);

export const playIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path d="M10.4546 6L1.54688 12V0L10.4546 6Z" fill="#D4D8DE" />
  </svg>
);

export const pauseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path d="M0.5 0H4.5V12H0.5V0Z" fill="#D4D8DE" />
    <path d="M7.5 0H11.5V12H7.5V0Z" fill="#D4D8DE" />
  </svg>
);

export const reviewBarMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 708 353"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3824_717)">
      <path d="M0 96H325V274.5L238 348H0V96Z" fill="#202020" />
    </g>
    <g filter="url(#filter1_di_3824_717)">
      <path
        d="M-0.5 0.5H708V275.5H323.5L219 102.5H-0.5V0.5Z"
        fill="url(#paint0_linear_3824_717)"
      />
      <path
        d="M-0.5 0.5H708V275.5H323.5L219 102.5H-0.5V0.5Z"
        fill="#020202"
        fillOpacity="0.1"
      />
      <path
        d="M-0.5 0.5H708V275.5H323.5L219 102.5H-0.5V0.5Z"
        fill="url(#paint1_linear_3824_717)"
        fillOpacity="0.4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3824_717"
        x="-2.5"
        y="95.5"
        width="330"
        height="257"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3824_717"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3824_717"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_3824_717"
        x="-3.1"
        y="0.5"
        width="713.7"
        height="280.2"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.6" />
        <feGaussianBlur stdDeviation="1.3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3824_717"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3824_717"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.3" />
        <feGaussianBlur stdDeviation="0.325" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_3824_717"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3824_717"
        x1="-43.6523"
        y1="-44.1947"
        x2="985.53"
        y2="-45.5758"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#292B30" />
        <stop offset="0.518171" stopColor="#3B3F47" />
        <stop offset="1" stopColor="#262626" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3824_717"
        x1="767.5"
        y1="-63.2499"
        x2="567"
        y2="222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#5B5B5B" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const reviewBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1703 441"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3776_12160)">
      <rect x="-1" y="111" width="1075" height="249" fill="#202020" />
    </g>
    <g filter="url(#filter1_di_3776_12160)">
      <path
        d="M0 0H1703V430H1079.5L848 147.5H0V0Z"
        fill="url(#paint0_linear_3776_12160)"
      />
      <path
        d="M0 0H1703V430H1079.5L848 147.5H0V0Z"
        fill="#020202"
        fillOpacity="0.1"
      />
      <path
        d="M0 0H1703V430H1079.5L848 147.5H0V0Z"
        fill="url(#paint1_linear_3776_12160)"
        fillOpacity="0.4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3776_12160"
        x="-6"
        y="110"
        width="1085"
        height="259"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3776_12160"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3776_12160"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_3776_12160"
        x="-5.2"
        y="0"
        width="1713.4"
        height="440.4"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5.2" />
        <feGaussianBlur stdDeviation="2.6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3776_12160"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3776_12160"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.6" />
        <feGaussianBlur stdDeviation="0.65" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_3776_12160"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3776_12160"
        x1="22.6954"
        y1="-89.3898"
        x2="2081.06"
        y2="-92.1521"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#292B30" />
        <stop offset="0.518171" stopColor="#3B3F47" />
        <stop offset="1" stopColor="#262626" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3776_12160"
        x1="1645"
        y1="-127.501"
        x2="1244"
        y2="442.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#5B5B5B" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const bulletCoin = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 68 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.6425 34.4282C65.6425 52.0872 51.3271 66.4026 33.6682 66.4026C16.0094 66.4026 1.694 52.0872 1.694 34.4282C1.694 16.7692 16.0094 2.45377 33.6682 2.45377C51.3271 2.45377 65.6425 16.7692 65.6425 34.4282ZM33.88 60.4736C48.1474 60.4736 59.7135 48.9075 59.7135 34.6399C59.7135 20.3724 48.1474 8.80631 33.88 8.80631C19.6125 8.80631 8.0465 20.3724 8.0465 34.6399C8.0465 48.9075 19.6125 60.4736 33.88 60.4736Z"
      fill="#373737"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.76 34.6399C67.76 53.3515 52.5914 68.5201 33.88 68.5201C15.1686 68.5201 0 53.3515 0 34.6399C0 15.9284 15.1686 0.759766 33.88 0.759766C52.5914 0.759766 67.76 15.9284 67.76 34.6399ZM33.6682 66.4026C51.3271 66.4026 65.6425 52.0872 65.6425 34.4282C65.6425 16.7692 51.3271 2.45377 33.6682 2.45377C16.0094 2.45377 1.694 16.7692 1.694 34.4282C1.694 52.0872 16.0094 66.4026 33.6682 66.4026Z"
      fill="url(#paint0_linear_3715_36131)"
    />
    <path
      d="M55.8691 28.3652C54.5257 23.6567 51.7051 19.5 47.8185 16.5112C43.8343 13.4474 38.9517 11.7814 33.9257 11.7709C28.8996 11.7603 24.0101 13.4059 20.0131 16.453C16.114 19.4255 13.276 23.5703 11.9129 28.2731C11.8562 28.4689 11.9724 28.6719 12.1691 28.7255C12.3657 28.7791 12.5683 28.6629 12.6252 28.4672C13.9456 23.9208 16.6905 19.9141 20.4606 17.04C24.3286 14.0912 29.0603 12.4988 33.9241 12.509C38.7879 12.5192 43.513 14.1314 47.3686 17.0964C51.1266 19.9863 53.8547 24.0044 55.1561 28.5563C55.2121 28.7523 55.4142 28.8693 55.611 28.8165C55.8079 28.7638 55.925 28.5612 55.8691 28.3652Z"
      fill="url(#paint1_linear_3715_36131)"
    />
    <path
      d="M55.8691 40.914C54.5257 45.6225 51.7051 49.7791 47.8185 52.7679C43.8343 55.8318 38.9517 57.4978 33.9257 57.5083C28.8996 57.5188 24.0101 55.8733 20.0131 52.8262C16.114 49.8537 13.276 45.7089 11.9129 41.006C11.8562 40.8103 11.9724 40.6072 12.1691 40.5537C12.3657 40.5001 12.5683 40.6162 12.6252 40.812C13.9456 45.3583 16.6905 49.365 20.4606 52.2392C24.3286 55.188 29.0603 56.7804 33.9241 56.7702C38.7879 56.76 43.5129 55.1478 47.3686 52.1828C51.1266 49.2929 53.8547 45.2748 55.1561 40.7229C55.2121 40.5269 55.4142 40.4099 55.611 40.4627C55.8079 40.5154 55.925 40.718 55.8691 40.914Z"
      fill="url(#paint2_linear_3715_36131)"
    />
    <path
      d="M27.4779 26.2174H24.0155C23.984 26.2174 23.955 26.2343 23.9395 26.2618L16.479 39.5103C16.4486 39.5644 16.4501 39.6307 16.483 39.6833L18.335 42.6462C18.351 42.6716 18.3789 42.6871 18.409 42.6871H27.6424C27.6739 42.6871 27.7029 42.6702 27.7184 42.6429L35.1255 29.5662C35.1494 29.524 35.1472 29.4718 35.1198 29.4318L33.1945 26.6183C33.1413 26.5406 33.0251 26.5457 32.9789 26.6277L25.7359 39.4901C25.6983 39.5567 25.6278 39.598 25.5514 39.598H20.3701C20.2076 39.598 20.1057 39.4226 20.1861 39.2814L27.5537 26.3475C27.5868 26.2894 27.5448 26.2174 27.4779 26.2174Z"
      fill="url(#paint3_linear_3715_36131)"
    />
    <path
      d="M37.8762 42.571C37.9078 42.571 37.9368 42.5541 37.9523 42.5266L43.4874 32.6971H39.8823L34.3952 42.4413C34.3625 42.4993 34.4045 42.571 34.4712 42.571H37.8762Z"
      fill="url(#paint4_linear_3715_36131)"
    />
    <path
      d="M36.1602 29.4972L41.7226 29.429L43.4874 32.6971L45.3528 29.3846L49.1879 29.3376L50.8719 26.3471C50.9046 26.2891 50.8625 26.2174 50.7958 26.2174H38.0582C38.0266 26.2174 37.9976 26.2343 37.9821 26.2618L36.1602 29.4972Z"
      fill="url(#paint5_linear_3715_36131)"
    />
    <path
      d="M52.8828 34.6815L56.8849 32.3709V36.9922L52.8828 34.6815Z"
      fill="url(#paint6_linear_3715_36131)"
    />
    <path
      d="M14.4844 34.6815L10.4823 32.3709V36.9922L14.4844 34.6815Z"
      fill="url(#paint7_linear_3715_36131)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
    </defs>
  </svg>
);

export const buildSquadIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 68 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67.76 34.6399C67.76 53.3515 52.5914 68.5201 33.88 68.5201C15.1686 68.5201 0 53.3515 0 34.6399C0 15.9284 15.1686 0.759766 33.88 0.759766C52.5914 0.759766 67.76 15.9284 67.76 34.6399ZM3.72052 34.6399C3.72052 51.2967 17.2234 64.7996 33.88 64.7996C50.5366 64.7996 64.0395 51.2967 64.0395 34.6399C64.0395 17.9832 50.5366 4.48031 33.88 4.48031C17.2234 4.48031 3.72052 17.9832 3.72052 34.6399Z"
      fill="#373737"
    />
    <path
      d="M67.76 34.6399C67.76 53.3515 52.5914 68.5201 33.88 68.5201C15.1686 68.5201 0 53.3515 0 34.6399C0 15.9284 15.1686 0.759766 33.88 0.759766C52.5914 0.759766 67.76 15.9284 67.76 34.6399ZM1.55316 34.6399C1.55316 52.4937 16.0264 66.967 33.88 66.967C51.7336 66.967 66.2068 52.4937 66.2068 34.6399C66.2068 16.7862 51.7336 2.31293 33.88 2.31293C16.0264 2.31293 1.55316 16.7862 1.55316 34.6399Z"
      fill="url(#paint0_linear_3713_19831)"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 24.1875 24.9922)"
      fill="#373737"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 39.7266 40.4883)"
      fill="#373737"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 8.70312 40.4805)"
      fill="#373737"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 22.25 23.0566)"
      fill="url(#paint1_linear_3713_19831)"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 37.7891 38.5527)"
      fill="url(#paint2_linear_3713_19831)"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 6.76562 38.5449)"
      fill="url(#paint3_linear_3713_19831)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3713_19831"
        x1="33.88"
        y1="0.759766"
        x2="33.88"
        y2="68.5201"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3713_19831"
        x1="8.23267"
        y1="0"
        x2="8.23267"
        y2="16.4653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3713_19831"
        x1="8.23267"
        y1="0"
        x2="8.23267"
        y2="16.4653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3713_19831"
        x1="8.23267"
        y1="0"
        x2="8.23267"
        y2="16.4653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
    </defs>
  </svg>
);

export const greenGlowBox = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 313 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_3655_3)">
      <rect
        x="6"
        y="6.99023"
        width="301"
        height="62"
        rx="14"
        stroke="#00FFCC"
        strokeWidth="4"
      />
    </g>
    <rect
      x="6"
      y="6.99023"
      width="301"
      height="62"
      rx="14"
      stroke="#68FFE5"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_f_3655_3"
        x="0"
        y="0.990234"
        width="313"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_3655_3"
        />
      </filter>
    </defs>
  </svg>
);

export const orangeGlowBox = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 283 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_12_188)">
      <rect
        x="6"
        y="6"
        width="271"
        height="62"
        rx="14"
        stroke="#FF5900"
        strokeWidth="4"
      />
    </g>
    <rect
      x="6"
      y="6"
      width="271"
      height="62"
      rx="14"
      stroke="#FFA34E"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_f_12_188"
        x="0"
        y="0"
        width="283"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_12_188"
        />
      </filter>
    </defs>
  </svg>
);

export const blueGlowBox = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 208 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_3655_2)">
      <rect
        x="6"
        y="6"
        width="196"
        height="62"
        rx="14"
        stroke="#12C9E9"
        strokeWidth="4"
      />
    </g>
    <rect
      x="6"
      y="6"
      width="196"
      height="62"
      rx="14"
      stroke="#ABF4FF"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_f_3655_2"
        x="0"
        y="0"
        width="208"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_3655_2"
        />
      </filter>
    </defs>
  </svg>
);

export const importArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 65 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.7678 20.7678C64.7441 19.7915 64.7441 18.2085 63.7678 17.2322L47.8579 1.32233C46.8816 0.34602 45.2986 0.34602 44.3223 1.32233C43.346 2.29864 43.346 3.88155 44.3223 4.85786L58.4645 19L44.3223 33.1421C43.346 34.1184 43.346 35.7014 44.3223 36.6777C45.2986 37.654 46.8816 37.654 47.8579 36.6777L63.7678 20.7678ZM-1.17735e-09 21.5L62 21.5L62 16.5L1.17735e-09 16.5L-1.17735e-09 21.5Z"
      fill="url(#paint0_linear_3081_9743)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3081_9743"
        x1="31"
        y1="19"
        x2="1.31915"
        y2="19"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1CFF00" />
        <stop offset="1" stopColor="#1CFF00" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const eaToClubArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 774 594"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3399_20259)">
      <path
        d="M30.4241 34.3619C18.5403 37.9938 11.8509 50.5718 15.4828 62.4556C19.1147 74.3394 31.6927 81.0289 43.5765 77.3969L30.4241 34.3619ZM592.025 587.385C600.812 596.172 615.058 596.172 623.845 587.385L767.035 444.197C775.822 435.41 775.822 421.164 767.035 412.377C758.249 403.59 744.002 403.59 735.216 412.377L607.936 539.655L480.657 412.375C471.87 403.589 457.624 403.588 448.837 412.375C440.051 421.162 440.05 435.408 448.837 444.195L592.025 587.385ZM43.5765 77.3969C176.585 36.7467 311.387 67.2146 413.285 153.689C515.216 240.191 585.437 383.941 585.435 571.475L630.435 571.475C630.437 372.506 555.689 215.518 442.402 119.379C329.082 23.211 178.415 -10.8673 30.4241 34.3619L43.5765 77.3969Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3399_20259"
        x="0.496094"
        y="0.59375"
        width="773.129"
        height="593.383"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" dy="-10" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.654902 0 0 0 0 0.803922 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3399_20259"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3399_20259"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const clubToSolutionArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1037 773"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3399_20261)">
      <path
        d="M1036.5 34.4208C1036.73 23.6537 1028.19 14.7385 1017.42 14.5082C1006.66 14.2779 997.742 22.8197 997.512 33.5868L1036.5 34.4208ZM22.7896 596.905C14.1773 603.371 12.4376 615.595 18.9039 624.207L124.277 764.552C130.743 773.164 142.967 774.904 151.579 768.438C160.192 761.971 161.931 749.748 155.465 741.136L61.7998 616.385L186.551 522.719C195.163 516.253 196.903 504.03 190.436 495.417C183.97 486.805 171.747 485.065 163.134 491.532L22.7896 596.905ZM997.512 33.5868C992.368 274.048 884.052 431.06 713.042 519.949C540.529 609.619 302.185 630.901 37.2453 593.193L31.75 631.804C300.813 670.098 548.433 649.464 731.029 554.553C915.129 458.86 1031.07 288.624 1036.5 34.4208L997.512 33.5868Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3399_20261"
        x="0.996094"
        y="0.5"
        width="1035.51"
        height="771.844"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" dy="-10" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.65658 0 0 0 0 0.804126 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3399_20261"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3399_20261"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const blueBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 6211 1036"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6233.13 1012.94L2647 1011.91L3286.36 110.805L6233.13 110.754V1012.94Z"
      fill="url(#paint0_linear_3394_15700)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6233.12 903.609L2737.39 902.1L3365.53 0.992737L6233.12 1.4259V903.609Z"
      fill="url(#paint1_linear_3394_15700)"
    />
    <g filter="url(#filter0_ddd_3394_15700)">
      <path
        d="M3429.18 82.5859H3571.83L3418.95 311.9H3276.3L3429.18 82.5859Z"
        fill="white"
      />
    </g>
    <path
      d="M3663.34 90.125H3805.99L3653.11 319.439H3510.46L3663.34 90.125Z"
      fill="#122931"
    />
    <path
      d="M3910.41 90.125H4053.06L3900.18 319.439H3757.54L3910.41 90.125Z"
      fill="#122931"
    />
    <defs>
      <filter
        id="filter0_ddd_3394_15700"
        x="3240.3"
        y="52.5859"
        width="361.523"
        height="289.312"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-32" dy="17" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3394_15700"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.997 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3394_15700"
          result="effect2_dropShadow_3394_15700"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.961 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3394_15700"
          result="effect3_dropShadow_3394_15700"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3394_15700"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3394_15700"
        x1="4279.09"
        y1="35.5535"
        x2="4895.23"
        y2="922.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3394_15700"
        x1="4193.09"
        y1="-247.704"
        x2="5126.39"
        y2="1243.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const redBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 6403 1035"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-9.9989 111.008L2685.23 112.096L2179.03 1022.99H-9.9989V111.008Z"
      fill="url(#paint0_linear_3394_15711)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-4.01434 0L2611.95 1.08829L2114.65 911.987H-4.01434V0Z"
      fill="url(#paint1_linear_3394_15711)"
    />
    <g filter="url(#filter0_ddd_3394_15711)">
      <path
        d="M2325.81 77.0625H2470.01L2343.22 308.868H2199.02L2325.81 77.0625Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_ddd_3394_15711)">
      <path
        d="M2098.36 77.0625H2242.55L2115.77 308.868H1971.57L2098.36 77.0625Z"
        fill="white"
      />
    </g>
    <path
      d="M1870.9 82.5078H2015.1L1888.32 314.314H1744.12L1870.9 82.5078Z"
      fill="#2F181A"
    />
    <defs>
      <filter
        id="filter0_ddd_3394_15711"
        x="2169.02"
        y="47.0625"
        width="330.984"
        height="291.805"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-24" dy="14" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3394_15711"
          result="effect2_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3394_15711"
          result="effect3_dropShadow_3394_15711"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3394_15711"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_ddd_3394_15711"
        x="1941.57"
        y="47.0625"
        width="330.984"
        height="291.805"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-24" dy="14" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3394_15711"
          result="effect2_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3394_15711"
          result="effect3_dropShadow_3394_15711"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3394_15711"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3394_15711"
        x1="1777.49"
        y1="1022.99"
        x2="2326.19"
        y2="38.6805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BB4538" />
        <stop offset="1" stopColor="#E97F81" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3394_15711"
        x1="1587.88"
        y1="982.18"
        x2="1917.4"
        y2="-116.816"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC2837" />
        <stop offset="0.995359" stopColor="#F64E6A" />
      </linearGradient>
    </defs>
  </svg>
);

export const yellowBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1148 3978"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1071.42 151.492L0.00158691 688.492V0.992188V3517.44L535.712 3919.44L1071.42 3517.44L1071.42 151.492Z"
      fill="url(#paint0_linear_3399_20055)"
    />
    <path
      d="M1071.42 151.492L0.00158691 688.492V0.992188V3517.44L535.712 3919.44L1071.42 3517.44L1071.42 151.492Z"
      fill="black"
      fillOpacity="0.4"
    />
    <path
      d="M1148 221.992L76.5609 757.492L76.5615 61.8359L76.5585 3575.34L612.267 3977.34L1147.98 3575.34L1148 221.992Z"
      fill="url(#paint1_linear_3399_20055)"
    />
    <g filter="url(#filter0_ddd_3399_20055)">
      <path
        d="M751 948.992V790.207L1026 652.992V811.778L751 948.992Z"
        fill="white"
      />
      <path
        d="M751 1183.99V1025.21L1026 887.992V1046.78L751 1183.99Z"
        fill="white"
      />
      <path
        d="M751 713.992V555.207L1026 417.992V576.778L751 713.992Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd_3399_20055"
        x="721"
        y="387.992"
        width="335"
        height="832"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-18" dy="32" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3399_20055"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.699001 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3399_20055"
          result="effect2_dropShadow_3399_20055"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.693 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3399_20055"
          result="effect3_dropShadow_3399_20055"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3399_20055"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3399_20055"
        x1="966.048"
        y1="377.256"
        x2="326.305"
        y2="3897.31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDBAB" />
        <stop offset="0.171875" stopColor="#FFD26C" />
        <stop offset="0.609375" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3399_20055"
        x1="1042.63"
        y1="350.481"
        x2="402.885"
        y2="3870.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD26C" />
        <stop offset="0.666667" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
    </defs>
  </svg>
);

export const turquoiseBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1699 1362"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.25"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1699 1362H0V0H1699V1362Z"
      fill="url(#paint0_radial_3594_45715)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45715"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(793.5 729.5) rotate(88.3247) scale(359.154 685.536)"
      >
        <stop offset="0.211066" stopColor="#08FF77" stopOpacity="0.84" />
        <stop offset="1" stopColor="#00FFD6" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const greenBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1703 1363"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.25"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1706.02 1362.75H-1.46094V0.566406H1706.02V1362.75Z"
      fill="url(#paint0_radial_3594_45714)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45714"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(437.167 729.013) rotate(92.9305) scale(393.197 730.375)"
      >
        <stop stopColor="#08FF00" stopOpacity="0.57" />
        <stop offset="1" stopColor="#00FF9D" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const blueBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1700 1324"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1700 1324H-1V0H1700V1324Z"
      fill="url(#paint0_radial_3594_45719)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45719"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(703 588) rotate(82.1858) scale(525.883 854.63)"
      >
        <stop stopColor="#00FFF4" stopOpacity="0.57" />
        <stop offset="1" stopColor="#0200A4" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const orangeBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1696 1363"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1695.01 1362.19H0.8125V0H1695.01V1362.19Z"
      fill="url(#paint0_radial_3594_45696)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45696"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1159 664) rotate(91.9073) scale(510.783 948.794)"
      >
        <stop stopColor="#FF9F44" stopOpacity="0.57" />
        <stop offset="0.886788" stopColor="#FF2E00" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const blueBlur2 = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1701 1543"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.25"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1702.64 1543H0V0H1718L1702.64 1543Z"
      fill="url(#paint0_radial_3594_46620)"
      fillOpacity="0.75"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_46620"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1390.9 670.837) rotate(86.666) scale(515.385 928.393)"
      >
        <stop stopColor="#00FFAF" stopOpacity="0.57" />
        <stop offset="1" stopColor="#00FFEB" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const whiteBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 6397 1931"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1049.7L5325.09 641.031L6414 557.464V1438.73L0 1930.96V1049.7Z"
      fill="white"
    />
    <path
      d="M5119 177.964L6158.15 350.193L6414 310.582V0L5119 177.964Z"
      fill="#E2E2E2"
    />
    <path
      d="M5119 177.964L5140.5 584.964L5325.09 641.031L6414 557.464V392.599L6158.15 350.193L5119 177.964Z"
      fill="#9E9E9E"
    />
  </svg>
);

export const whiteBarMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 708 294"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.41786e-07 159.823L587.802 97.6015L708 84.8779L708 219.056L4.44777e-07 294.001L2.41786e-07 159.823Z"
      fill="white"
    />
    <path
      d="M565.053 27.0969L679.758 53.3198L708 47.2889L708 0.000975491L565.053 27.0969Z"
      fill="#E2E2E2"
    />
    <path
      d="M565.053 27.0969L567.427 89.065L587.802 97.6015L708 84.8779L708 59.7763L679.758 53.3198L565.053 27.0969Z"
      fill="#9E9E9E"
    />
  </svg>
);

export const yellowBarMobileGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 5443 4163"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5443 4162.5H0V0H5443V4162.5Z"
      fill="url(#paint0_radial_52_3499)"
      fillOpacity="0.75"
    />
    <path
      d="M2113.5 1545.58L2717.5 2617H5442.84V1545.58L2113.5 1545.58Z"
      fill="url(#paint1_linear_52_3499)"
    />
    <path
      d="M2113.5 1545.58L2717.5 2617H5442.84V1545.58L2113.5 1545.58Z"
      fill="black"
      fillOpacity="0.4"
    />
    <path
      d="M2068 1469.02L2650.5 2497H5442.84V1469.02L2068 1469.02Z"
      fill="url(#paint2_linear_52_3499)"
    />
    <g filter="url(#filter0_ddd_52_3499)">
      <path d="M2881 1840H2701.29L2546 1565H2725.71L2881 1840Z" fill="white" />
      <path d="M3152 1840H2972.83L2818 1565H2997.17L3152 1840Z" fill="white" />
      <path d="M2609 1840H2429.29L2274 1565H2453.71L2609 1840Z" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_ddd_52_3499"
        x="2244"
        y="1535"
        width="938"
        height="335"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-12" dy="22" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_52_3499"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.658824 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_52_3499"
          result="effect2_dropShadow_52_3499"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.66 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_52_3499"
          result="effect3_dropShadow_52_3499"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_52_3499"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_52_3499"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3454.5 2032.5) rotate(90) scale(1573 2024.74)"
      >
        <stop stopColor="#FFC500" stopOpacity="0.57" />
        <stop offset="1" stopColor="#A44F00" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_52_3499"
        x1="2352.76"
        y1="1650.95"
        x2="5872.82"
        y2="2290.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDBAB" />
        <stop offset="0.171875" stopColor="#FFD26C" />
        <stop offset="0.609375" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_52_3499"
        x1="2217.98"
        y1="1574.37"
        x2="5738.04"
        y2="2214.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD26C" />
        <stop offset="0.666667" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
    </defs>
  </svg>
);

export const redBarMobileGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 5444 5068"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 5068L0 5068V0H5444V5068Z"
      fill="url(#paint0_radial_52_3497)"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.000732422 2069.57H3044L2424.5 3093H0.000732422V2069.57Z"
      fill="url(#paint1_linear_52_3497)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1945H2980L2356 2968.43H0V1945Z"
      fill="url(#paint2_linear_52_3497)"
    />
    <g filter="url(#filter0_ddd_52_3497)">
      <path
        d="M2638.72 2041.7H2812.9L2638.23 2321.7H2464.05L2638.72 2041.7Z"
        fill="white"
      />
      <path
        d="M2363.98 2041.7H2538.16L2363.49 2321.7H2189.31L2363.98 2041.7Z"
        fill="white"
      />
    </g>
    <path
      d="M2091.67 2048.81H2265.85L2091.18 2328.81H1917L2091.67 2048.81Z"
      fill="#2F181A"
    />
    <defs>
      <filter
        id="filter0_ddd_52_3497"
        x="2151.31"
        y="2011.7"
        width="691.594"
        height="340"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-34" dy="16" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_52_3497"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.384314 0 0 0 0 0.679843 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_52_3497"
          result="effect2_dropShadow_52_3497"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.384314 0 0 0 0 0.678431 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_52_3497"
          result="effect3_dropShadow_52_3497"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_52_3497"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_52_3497"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2233.19 2592.91) rotate(92.9104) scale(1462.86 2698.7)"
      >
        <stop stopColor="#FF0073" stopOpacity="0.57" />
        <stop offset="1" stopColor="#A44500" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_52_3497"
        x1="1998.92"
        y1="3093"
        x2="2614.67"
        y2="1988.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BB4538" />
        <stop offset="1" stopColor="#E97F81" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_52_3497"
        x1="1786.14"
        y1="3047.2"
        x2="2155.92"
        y2="1813.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC2837" />
        <stop offset="0.995359" stopColor="#F64E6A" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueBarMobileGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 5444 4013"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.35"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 4013H0V0.5H5444V4013Z"
      fill="url(#paint0_radial_52_3495)"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 2089.01L1393 2089.01L2107.29 1065.58H5444V2089.01Z"
      fill="url(#paint1_linear_52_3495)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 1963.21L1482 1963.21L2185.59 941L5444 941V1963.21Z"
      fill="url(#paint2_linear_52_3495)"
    />
    <g filter="url(#filter0_ddd_52_3495)">
      <path
        d="M2253.02 1030H2425.66L2240.64 1300.8H2068L2253.02 1030Z"
        fill="white"
      />
    </g>
    <path
      d="M2487.02 1038H2659.66L2474.64 1308.8H2302L2487.02 1038Z"
      fill="#122931"
    />
    <path
      d="M2726.02 1038H2898.66L2713.64 1308.8H2541L2726.02 1038Z"
      fill="#122931"
    />
    <defs>
      <filter
        id="filter0_ddd_52_3495"
        x="2030"
        y="1000"
        width="425.658"
        height="330.799"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-34" dy="16" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_52_3495"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.997 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_52_3495"
          result="effect2_dropShadow_52_3495"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.961 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_52_3495"
          result="effect3_dropShadow_52_3495"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_52_3495"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_52_3495"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3564.17 1512.02) rotate(92.9593) scale(1478.22 2772.69)"
      >
        <stop stopColor="#00C0FF" stopOpacity="0.57" />
        <stop offset="1" stopColor="#00FFF0" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_52_3495"
        x1="3454.4"
        y1="980.109"
        x2="4153.35"
        y2="1986.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_52_3495"
        x1="3130.87"
        y1="658.892"
        x2="4189.6"
        y2="2350.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueTopGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1728 870"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="1728" height="870" fill="url(#paint0_linear_356_1545)" />
    <defs>
      <linearGradient
        id="paint0_linear_356_1545"
        x1="864"
        y1="0"
        x2="864"
        y2="870"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02CEFF" stopOpacity="0.22" />
        <stop offset="1" stopColor="#151515" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueSubscriptionBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1693 342"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1310.5 341.598L0 341.599L382.287 37.1178L1692.79 37.1175L1310.5 341.598Z"
      fill="url(#paint0_linear_356_1525)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1288.5 304.488L46.9102 304.482L422.485 0.000151468L1664.07 0.0063325L1288.5 304.488Z"
      fill="url(#paint1_linear_356_1525)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_356_1525"
        x1="1087.84"
        y1="11.6587"
        x2="1238.96"
        y2="396.719"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_356_1525"
        x1="917.298"
        y1="-84.0204"
        x2="1137.77"
        y2="539.156"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueSubscriptionBarMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 768 1591"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="768" height="1591" fill="#151515" />
    <rect
      width="768"
      height="1591"
      fill="url(#paint0_linear_12_188)"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M768.001 300L0.00127411 299.757L0 299.757L0.00127411 225.257L166.043 74.4534H768.001V300Z"
      fill="url(#paint1_linear_12_188)"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M768.001 272.547L0.00127411 272.294V224.609L192.124 47L768.001 47V272.547Z"
      fill="url(#paint2_linear_12_188)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12_188"
        x1="384"
        y1="0"
        x2="384"
        y2="1591"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CFFF" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12_188"
        x1="390.222"
        y1="321.129"
        x2="573.764"
        y2="118.991"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12_188"
        x1="513.176"
        y1="-15.1733"
        x2="693.168"
        y2="430.994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const redIncludedTierArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 27 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5 7.77817C25.8807 7.77817 27 8.89746 27 10.2782C27 11.6589 25.8807 12.7782 24.5 12.7782H8.5379L12.0842 16.3245C13.0605 17.3008 13.0605 18.8837 12.0842 19.86C11.1079 20.8363 9.52495 20.8363 8.54864 19.86L0.767767 12.0808C0.30292 11.6268 0 10.9793 0 10.2782C0 9.58262 0.297715 8.94 0.756162 8.4868L8.54594 0.732233C9.52225 -0.244078 11.1052 -0.244078 12.0815 0.732233C13.0578 1.70854 13.0578 3.29146 12.0815 4.26777L8.57107 7.77817H24.5Z"
      fill="url(#paint0_linear_164_9)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_164_9"
        x1="13.5"
        y1="0"
        x2="13.5"
        y2="20.5922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD6A74" />
        <stop offset="1" stopColor="#EE3C4C" />
      </linearGradient>
    </defs>
  </svg>
);

export const orangeIncludedTierArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 27 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5 7.77817C25.8807 7.77817 27 8.89746 27 10.2782C27 11.6589 25.8807 12.7782 24.5 12.7782H8.5379L12.0842 16.3245C13.0605 17.3008 13.0605 18.8837 12.0842 19.86C11.1079 20.8363 9.52495 20.8363 8.54864 19.86L0.767767 12.0808C0.30292 11.6268 0 10.9793 0 10.2782C0 9.58262 0.297715 8.94 0.756162 8.4868L8.54594 0.732233C9.52225 -0.244078 11.1052 -0.244078 12.0815 0.732233C13.0578 1.70854 13.0578 3.29146 12.0815 4.26777L8.57107 7.77817H24.5Z"
      fill="url(#paint0_linear_164_10)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_164_10"
        x1="13.5"
        y1="0"
        x2="13.5"
        y2="20.5922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8F35" />
        <stop offset="1" stopColor="#FF6841" />
      </linearGradient>
    </defs>
  </svg>
);

export const greenDiscountBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 109 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16419"
      y="14.347"
      width="106.5"
      height="4.85802"
      transform="rotate(-7 1.16419 14.347)"
      fill="#C3E7E3"
      stroke="url(#paint0_linear_3667_149)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3667_149"
        x1="2"
        y1="15"
        x2="105.841"
        y2="18.823"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#12A394" />
        <stop offset="1" stopColor="#0B9587" />
      </linearGradient>
    </defs>
  </svg>
);

export const redDiscountBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 109 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16419"
      y="14.347"
      width="106.5"
      height="4.85802"
      transform="rotate(-7 1.16419 14.347)"
      fill="#FCD2D5"
      stroke="url(#paint0_linear_103_386)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_103_386"
        x1="2"
        y1="15"
        x2="105.841"
        y2="18.823"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F34F5C" />
        <stop offset="1" stopColor="#EE3F4E" />
      </linearGradient>
    </defs>
  </svg>
);

export const orangeDiscountBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 109 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16419"
      y="14.347"
      width="106.5"
      height="4.85802"
      transform="rotate(-7 1.16419 14.347)"
      fill="#FFDACF"
      stroke="url(#paint0_linear_103_458)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_103_458"
        x1="3.82252"
        y1="16.561"
        x2="104.493"
        y2="16.8371"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF713C" />
        <stop offset="1" stopColor="#FF5643" />
      </linearGradient>
    </defs>
  </svg>
);

export const mostPopularBanner = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 195 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M190.643 186.125L190.643 194.931C190.643 194.931 194.036 195.38 194.03 192.431C194.025 189.482 190.643 186.125 190.643 186.125Z"
      fill="url(#paint0_linear_176_181)"
    />
    <path
      d="M8.14834 3.3869L0.0244643 3.38702C0.0244643 3.38702 -0.424528 -0.00521786 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint1_linear_176_181)"
    />
    <path
      d="M8.14834 3.3869L99.3959 94.7561L190.643 186.125C190.643 186.125 194.025 189.482 194.03 192.431C194.03 189.292 194.029 119.746 194.03 117.238C194.031 114.731 190.643 111.585 190.643 111.585L82.1955 3.3869C82.1955 3.3869 79.0414 -0.00114104 76.534 2.88294e-07C74.0265 0.00114162 5.6637 0.000244017 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint2_linear_176_181)"
    />
    <path
      d="M8.14834 3.3869L99.3959 94.7561L190.643 186.125C190.643 186.125 194.025 189.482 194.03 192.431C194.03 189.292 194.029 119.746 194.03 117.238C194.031 114.731 190.643 111.585 190.643 111.585L82.1955 3.3869C82.1955 3.3869 79.0414 -0.00114104 76.534 2.88294e-07C74.0265 0.00114162 5.6637 0.000244017 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint3_linear_176_181)"
      fillOpacity="0.5"
    />
    <path
      d="M8.14834 3.3869L99.3959 94.7561L190.643 186.125C190.643 186.125 194.025 189.482 194.03 192.431C194.03 189.292 194.029 119.746 194.03 117.238C194.031 114.731 190.643 111.585 190.643 111.585L82.1955 3.3869C82.1955 3.3869 79.0414 -0.00114104 76.534 2.88294e-07C74.0265 0.00114162 5.6637 0.000244017 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint4_linear_176_181)"
      fillOpacity="0.8"
    />
    <path
      d="M190.643 194.931L190.643 186.125L99.3959 94.7561L8.14834 3.3869L0.0244643 3.38702L3.63495 3.38697L190.643 190.442L190.643 194.931Z"
      fill="url(#paint5_linear_176_181)"
      fillOpacity="0.2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_176_181"
        x1="185.958"
        y1="156.306"
        x2="200.755"
        y2="159.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#232323" />
        <stop offset="1" stopColor="#B3562A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_176_181"
        x1="41"
        y1="1.4766e-06"
        x2="35.3887"
        y2="14.1004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#232323" />
        <stop offset="1" stopColor="#D36835" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_176_181"
        x1="44.5"
        y1="4.49996"
        x2="176.861"
        y2="149.516"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8F34" />
        <stop offset="0.515625" stopColor="#FFBF2C" />
        <stop offset="1" stopColor="#FF7A3A" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_176_181"
        x1="178"
        y1="147.5"
        x2="204"
        y2="147.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD9238" stopOpacity="0" />
        <stop offset="0.512603" stopColor="#FFBB3F" />
        <stop offset="1" stopColor="#FF8E39" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_176_181"
        x1="32"
        y1="17"
        x2="31"
        y2="-10"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD9238" stopOpacity="0" />
        <stop offset="0.512603" stopColor="#FFBB3F" />
        <stop offset="0.78641" stopColor="#FF8E39" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_176_181"
        x1="194"
        y1="189.5"
        x2="4.83906"
        y2="3.6728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="0.09375" />
        <stop offset="0.895833" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const mostPopularBannerMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 235 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M230.391 2.4C230.391 2.4 234.591 2.4 234.591 1.8C234.591 0.6 230.391 0 230.391 0V2.4Z"
      fill="url(#paint0_linear_330_8)"
    />
    <path
      d="M230.391 2.4L28.7333 2.59291L0 31.2025L28.7335 59.9999L230.391 60C232.412 60 234.602 58.8 234.602 54C234.602 49.2 234.591 24.2942 234.591 1.8C234.591 2.4 230.391 2.4 230.391 2.4Z"
      fill="url(#paint1_linear_330_8)"
    />
    <path
      d="M230.391 2.4L28.7333 2.59291L0 31.2025L28.7335 59.9999L230.391 60C232.412 60 234.602 58.8 234.602 54C234.602 49.2 234.591 24.2942 234.591 1.8C234.591 2.4 230.391 2.4 230.391 2.4Z"
      fill="url(#paint2_linear_330_8)"
      fillOpacity="0.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_330_8"
        x1="129"
        y1="2.5"
        x2="145.5"
        y2="8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B17D20" />
        <stop offset="1" stopColor="#533500" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_330_8"
        x1="145.5"
        y1="60"
        x2="111.5"
        y2="2.1688e-06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA437" />
        <stop offset="0.489583" stopColor="#FFB635" />
        <stop offset="1" stopColor="#FF9938" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_330_8"
        x1="225.5"
        y1="26"
        x2="236"
        y2="26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.730167" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.74" />
      </linearGradient>
    </defs>
  </svg>
);

export const subscriptionInfoIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6516 6.24961C13.6516 7.16088 12.9128 7.89961 12.0016 7.89961C11.0903 7.89961 10.3516 7.16088 10.3516 6.24961C10.3516 5.33834 11.0903 4.59961 12.0016 4.59961C12.9128 4.59961 13.6516 5.33834 13.6516 6.24961Z"
      fill="#B2B2B2"
    />
    <path
      d="M10.75 9.5C10.75 8.94772 11.1977 8.5 11.75 8.5H12.25C12.8023 8.5 13.25 8.94772 13.25 9.5V18.75C13.25 19.3023 12.8023 19.75 12.25 19.75H11.75C11.1977 19.75 10.75 19.3023 10.75 18.75V9.5Z"
      fill="#B2B2B2"
    />
    <path
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.99311 12C1.99311 17.5267 6.47335 22.0069 12 22.0069C17.5267 22.0069 22.0069 17.5267 22.0069 12C22.0069 6.47335 17.5267 1.99311 12 1.99311C6.47335 1.99311 1.99311 6.47335 1.99311 12Z"
      fill="#B2B2B2"
    />
  </svg>
);

export const desktopRequiredCircleIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M90 50C90 72.0914 72.0914 90 50 90C27.9086 90 10 72.0914 10 50C10 27.9086 27.9086 10 50 10C72.0914 10 90 27.9086 90 50ZM25.0163 50C25.0163 63.7981 36.2019 74.9837 50 74.9837C63.7981 74.9837 74.9837 63.7981 74.9837 50C74.9837 36.2019 63.7981 25.0163 50 25.0163C36.2019 25.0163 25.0163 36.2019 25.0163 50Z"
      fill="white"
    />
  </svg>
);

export const curvedButton = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 272 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_858_10119)">
      <path
        d="M0 0H272V125H125C55.9644 125 0 69.0356 0 0Z"
        fill="url(#paint0_linear_858_10119)"
      />
      <path
        d="M0 0H272V125H125C55.9644 125 0 69.0356 0 0Z"
        fill="url(#paint1_linear_858_10119)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_858_10119"
        x="0"
        y="-1.44"
        width="272"
        height="126.44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-4.32" />
        <feGaussianBlur stdDeviation="0.72" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0916667 0 0 0 0 0.0916667 0 0 0 0 0.0916667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_858_10119"
        />
      </filter>
      <linearGradient
        id="paint0_linear_858_10119"
        x1="272"
        y1="5.625"
        x2="170.295"
        y2="209.492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222222" stopOpacity="0.98" />
        <stop offset="1" stopColor="#444444" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_858_10119"
        x1="16.4979"
        y1="145.146"
        x2="306.014"
        y2="42.261"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050" stopOpacity="0.67" />
        <stop offset="1" stopColor="#353535" />
      </linearGradient>
    </defs>
  </svg>
);

export const grayCrossButton = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 63 63"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61 31C61 14.4315 47.5685 1 31 1C14.4315 1 1 14.4315 1 31C1 47.5685 14.4315 61 31 61C47.5685 61 61 47.5685 61 31Z"
      fill="#FFF"
      fillOpacity="0.75"
    />
    <rect
      x="17.5684"
      y="48.9453"
      width="4.43668"
      height="44.3668"
      rx="2.21834"
      transform="rotate(-135 17.5684 48.9453)"
      fill="#232323"
    />
    <rect
      x="14.4316"
      y="16.9453"
      width="4.43668"
      height="44.3668"
      rx="2.21834"
      transform="rotate(-45 14.4316 16.9453)"
      fill="#232323"
    />
  </svg>
);

export const star = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.67442 0.358704L6.90806 4.10728L10.9002 4.10728L7.6705 6.42403L8.90414 10.1726L5.67442 7.85586L2.4447 10.1726L3.67834 6.42403L0.448619 4.10728L4.44077 4.10728L5.67442 0.358704Z"
      fill="currentColor"
    />
  </svg>
);

export const AIButtonThreads = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 659 313"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M172.405 134.662H144.004V163.083L122.704 183.609H31.9787M31.9787 176.504H117.181L133.748 159.925V129.136L137.693 125.189H172.405M172.405 116.505H133.748L128.226 122.031V157.557L117.181 168.609H42.2346M42.2346 163.083H107.714L121.915 148.873V112.557L129.015 105.452H172.405M172.405 95.9785H127.437L114.815 108.61V143.347L105.348 152.82H2M2 145.715H102.192L107.714 140.189V47.8209L117.181 38.3473H172.405M172.405 88.0838H117.181M117.181 79.3996H172.405M172.405 69.926H117.181M117.181 62.8208H172.405M133.748 53.3472H172.405M140.06 28.8737H172.405"
      stroke="url(#paint0_linear_1334_1624)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M259.939 150.56V166.866L171 255.732M270.547 150.56V166.866L176.712 260.624M184.871 268.777L279.522 174.203V150.56M290.13 150.56V174.203L190.583 273.669M229.749 273.669V260.624L299.105 191.325V150.56M309.713 150.56V164.42M319.504 150.56V311.172M358.674 281.006L348.066 270.407V150.56M356.543 150.56V220.675M365.519 150.56V208.446L377.758 220.675V301.388M388.365 301.388V220.675L372.046 204.369V150.56M380.206 150.56V201.923L401.421 223.121V301.388M433.243 301.388V231.274L389.997 188.063V150.56M399.789 151.375V179.91L455.274 235.35V301.388M465.065 301.388V235.35L407.132 177.465V150.56M415.292 150.56V175.834L478.121 238.611V301.388"
      stroke="url(#paint1_linear_1334_1624)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M476 153.737H495.023L536.591 195.294H650.024L656.365 201.633M656.365 183.32L650.729 177.685H533.773L502.068 145.989H476M476 137.537H509.114L528.841 157.259H652.138L657.774 162.894M657.774 144.58L652.138 138.946H527.432L517.568 129.085H476M467.022 38.9166H500.136L537.477 1.58575H643.159L648.796 7.22058M516.34 12.7164L500.136 28.9166H454.34M454.34 21.1687H482.522"
      stroke="url(#paint2_linear_1334_1624)"
      strokeWidth="3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1624"
        x1="-24"
        y1="100.918"
        x2="187"
        y2="78.918"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop offset="0.59375" stopColor="#BE7200" stopOpacity="0.432292" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1624"
        x1="310.85"
        y1="311.172"
        x2="310.85"
        y2="150.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop offset="0.59375" stopColor="#BE7200" stopOpacity="0.432292" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_1624"
        x1="614.773"
        y1="185.918"
        x2="441.773"
        y2="79.9181"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop offset="0.59375" stopColor="#BE7200" stopOpacity="0.432292" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const AIIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="51.8287"
      cy="51.8281"
      r="39"
      transform="rotate(25 51.8287 51.8281)"
      fill="#292929"
    />
    <g filter="url(#filter0_f_1185_1116)">
      <ellipse
        cx="45.8017"
        cy="45.7988"
        rx="45.8017"
        ry="45.7988"
        transform="matrix(0.996195 -0.0871502 0.0871614 0.996194 1.86719 9.73438)"
        fill="url(#paint0_radial_1185_1116)"
        fillOpacity="0.5"
      />
    </g>
    <g filter="url(#filter1_f_1185_1116)">
      <ellipse
        cx="51.5961"
        cy="51.7628"
        rx="18.8344"
        ry="18.8332"
        fill="url(#paint1_radial_1185_1116)"
      />
    </g>
    <path
      d="M85.8222 51.7786C85.8222 70.4769 70.6632 85.6355 51.9629 85.6355C33.2626 85.6355 18.1036 70.4769 18.1036 51.7786C18.1036 33.0803 33.2626 17.9218 51.9629 17.9218C70.6632 17.9218 85.8222 33.0803 85.8222 51.7786Z"
      stroke="url(#paint2_radial_1185_1116)"
      strokeOpacity="0.75"
      strokeWidth="13"
    />
    <g filter="url(#filter2_f_1185_1116)">
      <ellipse
        cx="3.61343"
        cy="3.61323"
        rx="3.61343"
        ry="3.61323"
        transform="matrix(0.96593 -0.258804 0.258835 0.965922 82.541 32.8438)"
        fill="url(#paint3_radial_1185_1116)"
      />
    </g>
    <ellipse
      cx="51.962"
      cy="51.7686"
      rx="30.5753"
      ry="30.5733"
      stroke="url(#paint4_radial_1185_1116)"
      strokeOpacity="0.75"
      strokeWidth="11"
    />
    <g filter="url(#filter3_f_1185_1116)">
      <ellipse
        cx="2.4769"
        cy="2.47676"
        rx="2.4769"
        ry="2.47676"
        transform="matrix(0.96593 -0.258804 0.258835 0.965922 75.8672 60.2656)"
        fill="url(#paint5_radial_1185_1116)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1185_1116"
        x="4.28164"
        y="4.1625"
        width="94.4094"
        height="94.4094"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.7"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <filter
        id="filter1_f_1185_1116"
        x="31.3617"
        y="31.5297"
        width="40.468"
        height="40.4641"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.7"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <filter
        id="filter2_f_1185_1116"
        x="82.3516"
        y="30.7812"
        width="9.22852"
        height="9.23438"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.5"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <filter
        id="filter3_f_1185_1116"
        x="75.9238"
        y="59.0391"
        width="5.95508"
        height="5.95312"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.25"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <radialGradient
        id="paint0_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.8017 45.7988) rotate(90) scale(45.7988 45.8017)"
      >
        <stop stopColor="#FFCB00" />
        <stop offset="0.438517" stopColor="#FF8B00" />
        <stop offset="0.489583" stopColor="#FF8D00" />
        <stop offset="0.536458" stopColor="#FF7D00" />
        <stop offset="1" stopColor="#FF4600" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.5961 51.7629) rotate(90) scale(18.8332 18.8344)"
      >
        <stop stopColor="#FFE61F" />
        <stop offset="0.666667" stopColor="#FF9812" />
        <stop offset="1" stopColor="#FF7100" stopOpacity="0.31" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.9629 51.7786) rotate(90) scale(40.3568 40.3594)"
      >
        <stop
          offset="0.922664"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
        <stop offset="0.94016" stopColor="#FFA725" />
        <stop offset="0.957501" stopColor="#FFD515" />
        <stop offset="0.975569" stopColor="#FFA200" />
        <stop
          offset="0.98901"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint3_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.61343 3.61323) rotate(90) scale(3.61323 3.61343)"
      >
        <stop stopColor="var(--color-brand-meta-orange)" />
        <stop offset="0.5625" stopColor="#FF8100" />
        <stop offset="1" stopColor="#FFB23E" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.962 51.7686) rotate(90) scale(30.5733 30.5753)"
      >
        <stop
          offset="0.894874"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
        <stop offset="0.944314" stopColor="#FFB955" />
        <stop
          offset="1"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.4769 2.47676) rotate(90) scale(2.47676 2.4769)"
      >
        <stop stopColor="var(--color-brand-meta-orange)" />
        <stop offset="0.5625" stopColor="#FF8100" />
        <stop offset="1" stopColor="#FFB23E" />
      </radialGradient>
    </defs>
  </svg>
);

export const selectedPlayerOnMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 85 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5C5.44772 5 5 5.44771 5 6V28L0 31V1C0 0.447716 0.447715 0 1 0H25L22 5H6Z"
      fill="var(--color-primary-light-blue)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84 114C84.5523 114 85 113.552 85 113V83L80 80V108C80 108.552 79.5523 109 79 109H63L60 114H84ZM0 113C0 113.552 0.447716 114 1 114H25L22 109H6C5.44772 109 5 108.552 5 108V80L0 83V113Z"
      fill="var(--color-primary-light-blue)"
    />
    <path
      d="M63 5H79C79.5523 5 80 5.44772 80 6V31L85 34V1C85 0.447715 84.5523 0 84 0H60L63 5Z"
      fill="var(--color-primary-light-blue)"
    />
  </svg>
);

export const SquadBuilderCloseIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_1888_19867)">
      <path
        d="M6.52941 23L3 19.4706L9.47059 13L3 6.52941L6.52941 3L13 9.47059L19.4706 3L23 6.52941L16.5294 13L23 19.4706L19.4706 23L13 16.5294L6.52941 23Z"
        fill="#392100"
      />
      <path
        d="M6.52941 23L3 19.4706L9.47059 13L3 6.52941L6.52941 3L13 9.47059L19.4706 3L23 6.52941L16.5294 13L23 19.4706L19.4706 23L13 16.5294L6.52941 23Z"
        stroke="var(--color-brand-meta-orange)"
      />
    </g>
    <path
      d="M6.52941 23L3 19.4706L9.47059 13L3 6.52941L6.52941 3L13 9.47059L19.4706 3L23 6.52941L16.5294 13L23 19.4706L19.4706 23L13 16.5294L6.52941 23Z"
      fill="#392100"
      stroke="#FFB23F"
      strokeWidth="0.5"
    />
    <defs>
      <filter
        id="filter0_f_1888_19867"
        x="0.292847"
        y="0.292847"
        width="25.4143"
        height="25.4143"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_1888_19867"
        />
      </filter>
    </defs>
  </svg>
);

export const suggestSquadLoadingStringsMobileTop = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 265 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76.0832 2V0.5H79.0832V2H76.0832ZM77.5832 15.8071H79.0832V16.4304L78.6415 16.8701L77.5832 15.8071ZM3.05831 92.1189C2.47122 92.7033 1.52148 92.7012 0.936991 92.1142C0.352505 91.5271 0.35461 90.5773 0.941694 89.9928L3.05831 92.1189ZM85.0976 2V0.5H88.0976V2H85.0976ZM86.5976 15.8071H88.0976V16.4304L87.656 16.8701L86.5976 15.8071ZM7.91227 96.261C7.32519 96.8455 6.37544 96.8434 5.79095 96.2563C5.20647 95.6692 5.20857 94.7195 5.79566 94.135L7.91227 96.261ZM14.8465 103.165C14.2594 103.749 13.3097 103.747 12.7252 103.16C12.1407 102.573 12.1428 101.623 12.7299 101.039L14.8465 103.165ZM94.2253 22.0203H95.7253V22.6436L95.2836 23.0833L94.2253 22.0203ZM92.7253 2V0.5H95.7253V2H92.7253ZM101.74 2V0.5H104.74V2H101.74ZM103.24 22.0203H104.74V22.6436L104.298 23.0833L103.24 22.0203ZM19.7005 107.307C19.1134 107.891 18.1636 107.889 17.5792 107.302C16.9947 106.715 16.9968 105.765 17.5839 105.181L19.7005 107.307ZM53.4265 106.244C53.4265 107.072 52.7549 107.744 51.9265 107.744C51.0981 107.744 50.4265 107.072 50.4265 106.244H53.4265ZM51.9265 95.198H50.4265V94.5747L50.8682 94.135L51.9265 95.198ZM110.867 36.5178H112.367V37.141L111.926 37.5808L110.867 36.5178ZM109.367 2V0.5H112.367V2H109.367ZM118.382 2V0.5H121.382V2H118.382ZM121.382 13.7361C121.382 14.5645 120.71 15.2361 119.882 15.2361C119.054 15.2361 118.382 14.5645 118.382 13.7361H121.382ZM126.703 2V0.5H129.703V2H126.703ZM129.703 138C129.703 138.828 129.032 139.5 128.203 139.5C127.375 139.5 126.703 138.828 126.703 138H129.703ZM162.549 111.394C163.136 111.978 163.138 112.928 162.554 113.515C161.969 114.102 161.019 114.104 160.432 113.52L162.549 111.394ZM152.476 103.482L151.418 104.545L150.976 104.105V103.482H152.476ZM150.976 2V0.5H153.976V2H150.976ZM158.18 2V0.5H161.18V2H158.18ZM161.18 61.3706C161.18 62.199 160.508 62.8706 159.68 62.8706C158.851 62.8706 158.18 62.199 158.18 61.3706H161.18ZM165.808 2V0.5H168.808V2H165.808ZM167.308 51.0152L166.249 52.0782L165.808 51.6385V51.0152H167.308ZM177.709 61.3706L178.767 60.3075L179.209 60.7473V61.3706H177.709ZM179.209 129.716C179.209 130.544 178.537 131.216 177.709 131.216C176.88 131.216 176.209 130.544 176.209 129.716H179.209ZM188.223 129.716C188.223 130.544 187.552 131.216 186.723 131.216C185.895 131.216 185.223 130.544 185.223 129.716H188.223ZM186.723 61.3706L187.782 60.3075L188.223 60.7473V61.3706H186.723ZM172.855 47.5635L171.797 48.6265L171.355 48.1867V47.5635H172.855ZM171.355 2V0.5H174.355V2H171.355ZM178.289 2V0.5H181.289V2H178.289ZM179.789 45.4924L178.731 46.5554L178.289 46.1157V45.4924H179.789ZM197.818 63.4416L198.876 62.3786L199.318 62.8184V63.4416H197.818ZM199.318 129.716C199.318 130.544 198.647 131.216 197.818 131.216C196.99 131.216 196.318 130.544 196.318 129.716H199.318ZM226.362 129.716C226.362 130.544 225.69 131.216 224.862 131.216C224.033 131.216 223.362 130.544 223.362 129.716H226.362ZM224.862 70.3452L225.92 69.2822L226.362 69.7219V70.3452H224.862ZM188.11 33.7564L187.052 34.8194L186.61 34.3796V33.7564H188.11ZM186.61 2V0.5H189.61V2H186.61ZM194.931 2.69037V1.19037H197.931V2.69037H194.931ZM196.431 26.8528L195.373 27.9158L194.931 27.4761V26.8528H196.431ZM243.584 73.797L244.642 72.7339L245.084 73.1737V73.797H243.584ZM245.084 129.716C245.084 130.544 244.413 131.216 243.584 131.216C242.756 131.216 242.084 130.544 242.084 129.716H245.084ZM253.405 129.716C253.405 130.544 252.734 131.216 251.905 131.216C251.077 131.216 250.405 130.544 250.405 129.716H253.405ZM251.905 73.797L252.964 72.7339L253.405 73.1737V73.797H251.905ZM202.672 24.7817L201.614 25.8447L201.172 25.405V24.7817H202.672ZM201.172 2V0.5H204.172V2H201.172ZM208.106 2V0.5H211.106V2H208.106ZM209.606 23.401L208.548 24.464L208.106 24.0243V23.401H209.606ZM263 76.5584L264.058 75.4954L264.5 75.9351V76.5584H263ZM264.5 129.716C264.5 130.544 263.828 131.216 263 131.216C262.172 131.216 261.5 130.544 261.5 129.716H264.5ZM79.0832 2V15.8071H76.0832V2H79.0832ZM78.6415 16.8701L3.05831 92.1189L0.941694 89.9928L76.5248 14.7441L78.6415 16.8701ZM88.0976 2V15.8071H85.0976V2H88.0976ZM87.656 16.8701L7.91227 96.261L5.79566 94.135L85.5393 14.7441L87.656 16.8701ZM12.7299 101.039L93.167 20.9573L95.2836 23.0833L14.8465 103.165L12.7299 101.039ZM92.7253 22.0203V2H95.7253V22.0203H92.7253ZM104.74 2V22.0203H101.74V2H104.74ZM104.298 23.0833L19.7005 107.307L17.5839 105.181L102.182 20.9573L104.298 23.0833ZM50.4265 106.244V95.198H53.4265V106.244H50.4265ZM50.8682 94.135L109.809 35.4548L111.926 37.5808L52.9848 96.261L50.8682 94.135ZM109.367 36.5178V2H112.367V36.5178H109.367ZM121.382 2V13.7361H118.382V2H121.382ZM129.703 2V138H126.703L126.703 2H129.703ZM160.432 113.52L151.418 104.545L153.534 102.419L162.549 111.394L160.432 113.52ZM150.976 103.482L150.976 2H153.976L153.976 103.482H150.976ZM161.18 2L161.18 61.3706H158.18L158.18 2H161.18ZM168.808 2L168.808 51.0152H165.808L165.808 2H168.808ZM168.366 49.9522L178.767 60.3075L176.651 62.4336L166.249 52.0782L168.366 49.9522ZM179.209 61.3706V129.716H176.209V61.3706H179.209ZM185.223 129.716V61.3706H188.223V129.716H185.223ZM185.665 62.4336L171.797 48.6265L173.913 46.5005L187.782 60.3075L185.665 62.4336ZM171.355 47.5635L171.355 2H174.355L174.355 47.5635H171.355ZM181.289 2L181.289 45.4924H178.289L178.289 2H181.289ZM180.847 44.4294L198.876 62.3786L196.76 64.5046L178.731 46.5554L180.847 44.4294ZM199.318 63.4416V129.716H196.318V63.4416H199.318ZM223.362 129.716V70.3452H226.362V129.716H223.362ZM223.803 71.4082L187.052 34.8194L189.169 32.6933L225.92 69.2822L223.803 71.4082ZM186.61 33.7564L186.61 2H189.61L189.61 33.7564H186.61ZM197.931 2.69037L197.931 26.8528H194.931L194.931 2.69037H197.931ZM197.49 25.7898L244.642 72.7339L242.526 74.86L195.373 27.9158L197.49 25.7898ZM245.084 73.797V129.716H242.084V73.797H245.084ZM250.405 129.716V73.797H253.405V129.716H250.405ZM250.847 74.86L201.614 25.8447L203.73 23.7187L252.964 72.7339L250.847 74.86ZM201.172 24.7817L201.172 2H204.172L204.172 24.7817H201.172ZM211.106 2L211.106 23.401H208.106L208.106 2H211.106ZM210.665 22.338L264.058 75.4954L261.942 77.6214L208.548 24.464L210.665 22.338ZM264.5 76.5584V129.716H261.5V76.5584H264.5Z"
      fill="url(#paint0_linear_1888_19756)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1888_19756"
        x1="120.848"
        y1="138"
        x2="120.848"
        y2="2.00002"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop
          offset="0.59375"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0.432292"
        />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const suggestSquadLoadingStringsMobileMid = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 183 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 106.151H19.0229L60.5913 147.708H174.024L180.365 154.047M180.365 135.734L174.729 130.099H57.7731L26.0684 98.4031H0M0 89.9509H33.1138L52.8413 109.673H176.138L181.774 115.308M181.774 96.9944L176.138 91.3596H51.4322L41.5685 81.4987H0M0.331741 39.3308H33.1275L70.4687 2H176.151L181.788 7.63483M49.3322 13.1307L33.1275 29.3308H0.331741M0.331741 21.5829H15.5137"
      stroke="url(#paint0_linear_1888_19758)"
      strokeWidth="3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1888_19758"
        x1="153.5"
        y1="29.5"
        x2="-1.03142"
        y2="46.772"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop
          offset="0.59375"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0.432292"
        />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const suggestSquadLoadingStringsMobileBottom = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 174 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      d="M172.405 106.287H173.905V109.287H172.405V106.287ZM144.004 107.787H142.504V106.287H144.004V107.787ZM144.004 136.208H145.504V136.846L145.045 137.288L144.004 136.208ZM122.704 156.734L123.745 157.814L123.309 158.234H122.704V156.734ZM31.9787 158.234C31.1503 158.234 30.4787 157.563 30.4787 156.734C30.4787 155.906 31.1503 155.234 31.9787 155.234V158.234ZM31.9787 151.129C31.1503 151.129 30.4787 150.458 30.4787 149.629C30.4787 148.801 31.1503 148.129 31.9787 148.129V151.129ZM117.181 149.629L118.242 150.689L117.803 151.129H117.181V149.629ZM133.748 133.05H135.248V133.671L134.81 134.111L133.748 133.05ZM133.748 102.261H132.248V101.64L132.687 101.201L133.748 102.261ZM137.693 98.3138L136.632 97.2535L137.071 96.8138H137.693V98.3138ZM172.405 96.8138H173.905V99.8138H172.405V96.8138ZM172.405 88.1296H173.905V91.1296H172.405V88.1296ZM133.748 89.6296L132.687 88.5693L133.127 88.1296H133.748V89.6296ZM128.226 95.1559H126.726V94.5349L127.165 94.0956L128.226 95.1559ZM128.226 130.682H129.726V131.303L129.287 131.742L128.226 130.682ZM117.181 141.734L118.242 142.795L117.803 143.234H117.181V141.734ZM42.2346 143.234C41.4061 143.234 40.7346 142.563 40.7346 141.734C40.7346 140.906 41.4061 140.234 42.2346 140.234V143.234ZM42.2346 137.708C41.4061 137.708 40.7346 137.037 40.7346 136.208C40.7346 135.38 41.4061 134.708 42.2346 134.708V137.708ZM107.714 136.208L108.775 137.269L108.336 137.708H107.714V136.208ZM121.915 121.998H123.415V122.619L122.976 123.058L121.915 121.998ZM121.915 85.6823H120.415V85.0613L120.854 84.622L121.915 85.6823ZM129.015 78.5771L127.954 77.5168L128.393 77.0771H129.015V78.5771ZM172.405 77.0771H173.905V80.0771H172.405V77.0771ZM172.405 67.6035H173.905V70.6035H172.405V67.6035ZM127.437 69.1035L126.376 68.0432L126.816 67.6035H127.437V69.1035ZM114.815 81.7349H113.315V81.1139L113.754 80.6747L114.815 81.7349ZM114.815 116.472H116.315V117.093L115.876 117.532L114.815 116.472ZM105.348 125.945L106.409 127.005L105.969 127.445H105.348V125.945ZM2 127.445C1.17157 127.445 0.5 126.774 0.5 125.945C0.5 125.117 1.17157 124.445 2 124.445V127.445ZM2 120.34C1.17157 120.34 0.5 119.668 0.5 118.84C0.5 118.011 1.17157 117.34 2 117.34V120.34ZM102.192 118.84L103.253 119.9L102.814 120.34H102.192V118.84ZM107.714 113.314H109.214V113.935L108.775 114.374L107.714 113.314ZM107.714 20.9459H106.214V20.3249L106.653 19.8857L107.714 20.9459ZM117.181 11.4723L116.12 10.412L116.56 9.97231H117.181V11.4723ZM172.405 9.97231H173.905V12.9723H172.405V9.97231ZM172.405 59.7088H173.905V62.7088H172.405V59.7088ZM117.181 62.7088C116.353 62.7088 115.681 62.0372 115.681 61.2088C115.681 60.3804 116.353 59.7088 117.181 59.7088V62.7088ZM117.181 54.0246C116.353 54.0246 115.681 53.3531 115.681 52.5246C115.681 51.6962 116.353 51.0246 117.181 51.0246V54.0246ZM172.405 51.0246H173.905V54.0246H172.405V51.0246ZM172.405 41.551H173.905V44.551H172.405V41.551ZM117.181 44.551C116.353 44.551 115.681 43.8795 115.681 43.051C115.681 42.2226 116.353 41.551 117.181 41.551V44.551ZM117.181 37.4458C116.353 37.4458 115.681 36.7742 115.681 35.9458C115.681 35.1174 116.353 34.4458 117.181 34.4458V37.4458ZM172.405 34.4458H173.905V37.4458H172.405V34.4458ZM133.748 27.9722C132.92 27.9722 132.248 27.3006 132.248 26.4722C132.248 25.6438 132.92 24.9722 133.748 24.9722V27.9722ZM172.405 24.9722H173.905V27.9722H172.405V24.9722ZM140.06 3.4987C139.231 3.4987 138.56 2.82713 138.56 1.9987C138.56 1.17027 139.231 0.498703 140.06 0.498703V3.4987ZM172.405 0.498703H173.905V3.4987H172.405V0.498703ZM172.405 109.287H144.004V106.287H172.405V109.287ZM145.504 107.787V136.208H142.504V107.787H145.504ZM145.045 137.288L123.745 157.814L121.663 155.654L142.963 135.128L145.045 137.288ZM122.704 158.234H31.9787V155.234H122.704V158.234ZM31.9787 148.129H117.181V151.129H31.9787V148.129ZM116.12 148.569L132.687 131.99L134.81 134.111L118.242 150.689L116.12 148.569ZM132.248 133.05V102.261H135.248V133.05H132.248ZM132.687 101.201L136.632 97.2535L138.754 99.3741L134.81 103.321L132.687 101.201ZM137.693 96.8138H172.405V99.8138H137.693V96.8138ZM172.405 91.1296H133.748V88.1296H172.405V91.1296ZM134.81 90.6899L129.287 96.2162L127.165 94.0956L132.687 88.5693L134.81 90.6899ZM129.726 95.1559V130.682H126.726V95.1559H129.726ZM129.287 131.742L118.242 142.795L116.12 140.674L127.165 129.622L129.287 131.742ZM117.181 143.234H42.2346V140.234H117.181V143.234ZM42.2346 134.708H107.714V137.708H42.2346V134.708ZM106.653 135.148L120.854 120.938L122.976 123.058L108.775 137.269L106.653 135.148ZM120.415 121.998V85.6823H123.415V121.998H120.415ZM120.854 84.622L127.954 77.5168L130.076 79.6374L122.976 86.7426L120.854 84.622ZM129.015 77.0771H172.405V80.0771H129.015V77.0771ZM172.405 70.6035H127.437V67.6035H172.405V70.6035ZM128.498 70.1637L115.876 82.7952L113.754 80.6747L126.376 68.0432L128.498 70.1637ZM116.315 81.7349V116.472H113.315V81.7349H116.315ZM115.876 117.532L106.409 127.005L104.287 124.885L113.754 115.411L115.876 117.532ZM105.348 127.445H2V124.445H105.348V127.445ZM2 117.34H102.192V120.34H2V117.34ZM101.131 117.78L106.653 112.253L108.775 114.374L103.253 119.9L101.131 117.78ZM106.214 113.314V20.9459H109.214V113.314H106.214ZM106.653 19.8857L116.12 10.412L118.242 12.5326L108.775 22.0062L106.653 19.8857ZM117.181 9.97231H172.405V12.9723H117.181V9.97231ZM172.405 62.7088H117.181V59.7088H172.405V62.7088ZM117.181 51.0246H172.405V54.0246H117.181V51.0246ZM172.405 44.551H117.181V41.551H172.405V44.551ZM117.181 34.4458H172.405V37.4458H117.181V34.4458ZM133.748 24.9722H172.405V27.9722H133.748V24.9722ZM140.06 0.498703H172.405V3.4987H140.06V0.498703Z"
      fill="url(#paint0_linear_1888_19757)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1888_19757"
        x1="68.5"
        y1="11"
        x2="172"
        y2="55.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop
          offset="0.59375"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0.432292"
        />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const includeExcludePlayer = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 104 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H104V61H94V10H10V100H54V110H0V0Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 91C20.5358 66.0489 25.4393 57.9418 40.2556 51.3155C40.2556 51.3155 32.5216 40.8616 33.6416 33.5401C35.1111 23.9331 42.5242 16.7867 52.2405 17.0049C61.7198 17.2177 68.5034 24.1803 70.0191 33.5401C71.1942 40.7975 63.8183 51.3155 63.8183 51.3155C69.8329 54.0243 74.0837 57.0701 77.085 61H69.5H54V70.5V91H20Z"
      fill="url(#paint0_linear_6669_17675)"
    />
    <path d="M54 61V70.5L69.5 61H54Z" fill="url(#paint1_linear_6669_17675)" />
    <path
      d="M54 91H84.074C83.6509 76.7484 82.1407 67.6199 77.085 61H69.5L54 70.5V91Z"
      fill="url(#paint2_linear_6669_17675)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6669_17675"
        x1="25.5"
        y1="24"
        x2="87.5"
        y2="93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.422536" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6669_17675"
        x1="25.5"
        y1="24"
        x2="87.5"
        y2="93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.422536" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6669_17675"
        x1="25.5"
        y1="24"
        x2="87.5"
        y2="93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.422536" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
